{
  "contacts": "Contacts",
  "contact": "contact",
  "add_contact": "Add contact",
  "delete_contact": "Delete contact"
}
